/** 机械设备参数固定业务键（与车辆字段 / 进场核载等业务对齐） */
export const EQUIPMENT_PARAM_KEY = {
  APPROVED_PERSON: 'approvedPenson',
  PRODUCTION_EFFICIENCY: 'productionEfficiency'
}

export const DEFAULT_EQUIPMENT_PARAMS = [
  {
    key: EQUIPMENT_PARAM_KEY.APPROVED_PERSON,
    label: '核载人数',
    value: null,
    unit: '人'
  },
  {
    key: EQUIPMENT_PARAM_KEY.PRODUCTION_EFFICIENCY,
    label: '生产效率',
    value: null,
    unit: ''
  }
]

export function isFixedEquipmentParamKey(key) {
  return (
    key === EQUIPMENT_PARAM_KEY.APPROVED_PERSON ||
    key === EQUIPMENT_PARAM_KEY.PRODUCTION_EFFICIENCY
  )
}

export function normalizePositiveInt(value) {
  if (value === '' || value === null || value === undefined) return null
  const n = parseInt(String(value).replace(/人/g, '').trim(), 10)
  if (isNaN(n) || n <= 0) return null
  return n
}

/** 从车辆库记录（含 paramJson）取核载人数 */
export function pickApprovedPensonFromCar(car) {
  if (!car) return null
  const fromField = normalizePositiveInt(car.approvedPenson)
  if (fromField != null) return fromField
  const list = Array.isArray(car.paramJson) ? car.paramJson : []
  for (let i = 0; i < list.length; i++) {
    const p = list[i]
    if (!p) continue
    if (
      p.key === EQUIPMENT_PARAM_KEY.APPROVED_PERSON ||
      p.label === '核载人数'
    ) {
      const n = normalizePositiveInt(p.value)
      if (n != null) return n
    }
  }
  return null
}

/** 参数列表为空时返回默认两项；已有数据则返回 null（表示沿用回填） */
export function buildDefaultParamsIfEmpty(paramList) {
  if (Array.isArray(paramList) && paramList.length > 0) return null
  return DEFAULT_EQUIPMENT_PARAMS.map((item) => Object.assign({}, item))
}

export function flattenParamFormFields(list) {
  const arr = Array.isArray(list) ? list : []
  const fields = { paramJson: arr }
  // 清空旧序号字段，避免删除后残留 keyN 干扰展示
  for (let i = 1; i <= 30; i++) {
    fields['key' + i] = ''
    fields['label' + i] = ''
    fields['value' + i] = ''
    fields['unit' + i] = ''
  }
  arr.forEach((item, index) => {
    const i = index + 1
    fields['key' + i] = item.key
    fields['label' + i] = item.label
    fields['value' + i] = item.value
    fields['unit' + i] = item.unit
  })
  return fields
}
